import { api } from '@/modules/apiv2';

export default {
  state: {
    scenarios: [],
  },

  getters: {
    scenarios(state) {
      return [...state.scenarios].sort((a, b) => a.name.localeCompare(b.name));
    },
  },

  mutations: {
    setScenarios(state, scenarios) {
      state.scenarios = scenarios;
    },

    setScenario(state, scenario) {
      const index = state.scenarios.findIndex((s) => s.id === scenario.id);
      console.log('setScenario mutation called with scenario:', scenario);
      if (index !== -1) {
        state.scenarios = [
          ...state.scenarios.slice(0, index),
          scenario,
          ...state.scenarios.slice(index + 1),
        ];
      } else {
        state.scenarios = [...state.scenarios, scenario];
      }
    },

    deleteScenario(state, scenarioId) {
      state.scenarios = state.scenarios.filter((s) => s.id !== scenarioId);
    },
  },

  actions: {
    async getScenarios({ commit, getters }) {
      const endpoint = getters.scenariosEndpoint;

      const data = await api.get(`${endpoint}`);
      commit('setScenarios', data);
      return data;
    },

    async getScenario({ commit, getters }, scenarioId) {
      const endpoint = getters.scenariosEndpoint;

      const data = await api.get(`${endpoint}/${scenarioId}`);
      commit('setScenario', data);
      return data;
    },

    async createScenario({ commit, getters }, scenario) {
      const endpoint = getters.scenariosEndpoint;

      const data = await api.post(endpoint, scenario);
      commit('setScenario', data);
      return data;
    },

    async updateScenario({ commit, getters }, scenario) {
      const endpoint = getters.scenariosEndpoint;

      const data = await api.put(`${endpoint}/${scenario.id}`, scenario);
      commit('setScenario', data);
      return data;
    },

    async deleteScenario({ commit, getters }, scenarioId) {
      const endpoint = getters.scenariosEndpoint;

      const response = await api.delete(`${endpoint}/${scenarioId}`);
      commit('deleteScenario', scenarioId);
      return response;
    },
  },
};
